module.exports = __webpack_public_path__ + "static/img/02.53aeaea.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/design/assets/02.png
// module id = 8sHS
// module chunks = 65